import { render, staticRenderFns } from "./app-footer.html?vue&type=template&id=58fba358&scoped=true&external"
import script from "./app-footer.vue?vue&type=script&lang=js"
export * from "./app-footer.vue?vue&type=script&lang=js"
import style0 from "./app-footer.css?vue&type=style&index=0&id=58fba358&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fba358",
  null
  
)

export default component.exports